// Handles viewport resize classes and background metrics.
import { useEffect } from 'react';
import {
  useBreakpoint,
  isPhoneBreakpoint,
  isBattlefieldBreakpoint,
} from '@/hooks/ui/useBreakpoint.js';
import { useDailyStats } from '@/features/tasks/hooks/status/use-task-metrics.js';

const QUICKBAR_HEIGHT = 'calc(80px + env(safe-area-inset-bottom, 0px))';

const AppLayoutInner = ({ children }) => {
  const currentBreakpoint = useBreakpoint();
  const isBattlefield = isBattlefieldBreakpoint(currentBreakpoint);
  useDailyStats();

  useEffect(() => {
    const isSmall = isPhoneBreakpoint(currentBreakpoint);
    if (isSmall) {
      document.documentElement.classList.add('is-small-screen');
      document.documentElement.style.setProperty(
        '--time-slot-height',
        'var(--time-slot-height-mobile)',
      );
    } else {
      document.documentElement.classList.remove('is-small-screen');
      document.documentElement.style.setProperty(
        '--time-slot-height',
        'var(--time-slot-height-desktop)',
      );
    }
    document.documentElement.dataset.breakpoint = currentBreakpoint;
  }, [currentBreakpoint]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--app-quickbar-height',
      isBattlefield ? QUICKBAR_HEIGHT : '0px',
    );
  }, [isBattlefield]);

  useEffect(() => {
    const root = document.documentElement;
    const chromeEl = document.getElementById('app-chrome');
    if (!chromeEl) return undefined;

    const syncChromeHeight = () => {
      root.style.setProperty(
        '--app-chrome-height',
        `${chromeEl.getBoundingClientRect().height}px`,
      );
    };

    syncChromeHeight();
    const observer = new ResizeObserver(syncChromeHeight);
    observer.observe(chromeEl);
    return () => observer.disconnect();
  }, []);

  return children;
};

export default AppLayoutInner;
